<template>
  <div :class="[{'has-error': validationErrors}, `cso-checkbox cso-checkbox--${modifier}` ]">
    <input type="checkbox"
           :id="name"
           :name="name"
           :validation-name="validationName"
           :disabled="disabled"
           v-model="currentValue"
           :data-cy="cypressName"
           @change="onInput"
           @checked="onInput"
           @click="onInput"
           @input="onInput"
           @blur="onBlur" />
    <label :for="name"
        :class="{'blueLink': blueLink, 'disabled': disabled}"
        :data-cy="cypressName + '-label'">
      <span v-html="label" />
      <p v-html="additionalInfo" v-if="additionalInfo" class="additional-info"></p>
      <cso-info-icon v-if="hint"
                     :content="hint" />
    </label>

    <div class="cso-checkbox--errors"
         v-if="validationErrors">
      <span v-for="(error, index) in validationErrors"
            :key="index">
        {{ error.message }}
      </span>
    </div>
  </div>
</template>
<script>
import validatedInputField from '@/mixins/validatedInputField'

import CsoInfoIcon from '@/components/core/composition/CsoInfoIcon.vue'

export default {
  name: 'CsoCheckbox',
  mixins: [validatedInputField],
  props: {
    modifier: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    blueLink: {
      type: Boolean,
      required: false,
      default: false
    },
    cypressName: {
      type: String,
      required: false
    },
    additionalInfo: {
      type: String,
      required: false
    }
  },
  components: {
    CsoInfoIcon
  }
}
</script>

<style lang="scss">
.cso-checkbox {
  /* base checkbox styling */
  [type='checkbox'] {
    position: absolute;
    left: -9999px;

    & + label {
      position: relative;
      padding-left: 36px;
      cursor: pointer;
      margin: 12px 0;
      word-break: break-word;
      font-size: 18px;
      line-height: 125%;
      font-family: $font-family-regular;
      color: $black;

      @include md {
        font-size: 16px;
      }

      h4 {
        font-size: 18px;
        font-weight: normal;

        @include md {
          font-size: 16px;
        }
      }

      p, .additional-info {
        margin: 0;
      }

      .additional-info {
        padding: 12px 0 4px;
      }

      a {
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    /* text label */
    & + label:before {
      content: '';
      position: absolute;
      left: 0;
      top: 2px;
      width: 24px;
      height: 24px;
      border: 1px solid $gray-4d;
      background: #fff;
      font-family: $font-family-regular;
      font-size: 14px;
    }

    /* check mark */
    & + label:after {
      background: url('/static/icons/check-mark.svg') no-repeat center / 18px;
      content: ' ';
      font-weight: bold;
      position: absolute;
      left: 0;
      top: 2px;
      padding-left: 5px;
      padding-top: 2px;
      width: 24px;
      height: 24px;
      font-size: 20px;
      line-height: 0.8;
      color: $black;
      transition: all 0.2s;
      font-family: $font-family-regular;
      border: 1px solid $gray-4d;
    }
  }

  /* checked */
  [type='checkbox'] {
    &:not(:checked) + label:after {
      opacity: 0;
      transform: scale(0);
    }

    &:checked + label:after {
      opacity: 1;
      transform: scale(1);
    }
  }

  /* focus */
  [type='checkbox']:focus-visible + label:before {
    outline: 2px solid $blue;
    outline-offset: 2px;
  }

  /* disabled checkbox */
  [type='checkbox']:disabled + label:before {
    border-color: $gray-f2;
    background-color: $gray-f2;
  }

  [type='checkbox']:disabled + label:after {
    color: $black;
    border-color: $gray-f2;
  }

  [type='checkbox']:disabled + label {
    cursor: not-allowed;
    color: $gray-dark;

    a {
      color: $gray-dark;
      cursor: pointer;
    }
  }

  [type='checkbox']:disabled + label.blueLink {
    cursor: not-allowed;

    a {
      color: $blue;;
      cursor: pointer;
    }
  }

  /* errors */
  .cso-checkbox--errors {
    color: $error;
    margin-bottom: 0.65em;
    padding-left: 36px;
  }

  &.has-error [type='checkbox'] + label:before {
    border: 2px solid $red-b6;
  }
}
</style>
